
    <h1 class="mat-dialog-title">{{data.adUnitName}}</h1>
    <mat-dialog-content>
      <textarea #foo
                title="Ad unit tag"
                class="mat-input-element textarea-note w-100 mb-3"
                [(ngModel)]="data.adUnitTag"
                width="100%" rows="10"></textarea>
      <p *ngIf="!data.hideSubtitle" class="mb-3">Please paste this tag into your ad server.</p>
    </mat-dialog-content>
    <mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="primary" (click)="onDownloadFile()" class="iconed  mb-3 mb-sm-0">
        <i class="fas fa-download"></i>
        <span>Download file</span>
      </button>
      <button mat-raised-button color="primary" [ngxClipboard]="foo" (cbOnSuccess)="onCopyToClipboard()" class="iconed  mb-3 mb-sm-0">
        <i class="fas fa-clipboard"></i>
        <span>Copy to clipboard</span>
      </button>
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
    </mat-dialog-actions>
  